<template>
  <div class="flex flex-row flex-nowrap gap-x-10 relative">
    <button
      @click="$router.go(-1)"
      class="flex flex-row justify-items-center focus:outline-none"
    >
      <span class="text-light-gray text-2xl pt-1/2">
        <RIcon class="h-4 w-2" icon="angle-left" />
      </span>
      <span class="pl-4 pb-px -mt-1 text-light-gray text-xl"> Назад </span>
    </button>
  </div>
</template>
